import devOne from '../assets/images/dev-1.svg';
import devTwo from '../assets/images/dev-2.svg';
import devThree from '../assets/images/dev-3.svg';

export const DEVELOPERS = [
  {
    nickname: 'Bumble-sakh',
    link: 'https://github.com/Bumble-sakh',
    name: 'firstDev',
    image: devOne,
    contribution: ['mainPage', 'search', 'tasks'],
  },
  {
    nickname: 'LilithPrimary',
    link: 'https://github.com/LilithPrimary',
    name: 'secondDev',
    image: devTwo,
    contribution: ['authorization', 'profile', 'checklistTask'],
  },
  {
    nickname: 'oxanacode',
    link: 'https://github.com/oxanacode',
    name: 'thirdDev',
    image: devThree,
    contribution: ['columns', 'dnd', 'taskFiles'],
  },
];

export const SCHOOL_LINK = 'https://rs.school/react/';
export const SCHOOL_TASK =
  'https://github.com/rolling-scopes-school/tasks/blob/master/tasks/react/project-management-system-EN.md';
